import React from "react";
import ItemValue from "../overview/itemValue";
import { IRealtimeData } from "../../../types";
import { Card, CardContent, CardHeader } from "@mui/material";
import AcquisitionChartWrapper from "../../dashboardRT/components/widgets/chart/acquisitionChartWrapper";
import { DashboardSchemaType } from "../../interruptions/types";
import { IDashboard } from "../../dashboardRT/types";

interface IProps {
  realtimeData: Record<string, IRealtimeData>;
  schemas: Record<DashboardSchemaType, any> | null;
  width: number;
}

const dashboard: IDashboard = {
    dashboardID: null,
    moduleID: 2,
    nodeType: "",
    nodeID: 0,
    name: "",
    layout: {
      components:[
        {
          key: "ld4n9enfycyo2o8ic4",
          title: "Variables",
          componentType: 1,
          column: 1,
          row: 1,
          columnSpan: 1,
          rowSpan: 1,
          config: {
             acquisitionCell: {
              key: "ld4n9io2v50wiak3e7o",
              module: 2,
              title: "Name",
              machine: "EAF",
              variables: [
                {
                  hash: "ld4nadw96zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_1_DIFF_PRESS",
                  title: "Compartment 1",
                  color: "#ef5350",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw93zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_2_DIFF_PRESS",
                  title: "Compartment 2",
                  color: "#ec407a",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                  },
                {
                  hash: "ld4nadw90zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_3_DIFF_PRESS",
                  title: "Compartment 3",
                  color: "#ab47bc",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw97zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_4_DIFF_PRESS",
                  title: "Compartment 4",
                  color: "#7e57c2",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw94zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_5_DIFF_PRESS",
                  title: "Compartment 5",
                  color: "#5c6bc0",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw91zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_6_DIFF_PRESS",
                  title: "Compartment 6",
                  color: "#42a5f5",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                   name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw98zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_7_DIFF_PRESS",
                  title: "Compartment 7",
                  color: "#29b6f6",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw95zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_8_DIFF_PRESS",
                  title: "Compartment 8",
                  color: "#26c6da",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw92zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_9_DIFF_PRESS",
                  title: "Compartment 9",
                  color: "#26a69a",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw99zh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_10_DIFF_PRESS",
                  title: "Compartment 10",
                  color: "#66bb6a",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw99ah1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_11_DIFF_PRESS",
                  title: "Compartment 11",
                  color: "#9ccc65",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                },
                {
                  hash: "ld4nadw99bh1jnfwl4c",
                  field: "EAFLOG.COMPARTMENT_12_DIFF_PRESS",
                  title: "Compartment 12",
                  color: "#d4e157",
                  unit: "",
                  decimals: 2,
                  limits: [],
                  annotations: [],
                  yAxis: {
                    name: "Pressure",
                    minimum: 0,
                    maximum: 10,
                    ticksCount: 5
                  }
                }
              ],
              events: []
            }
          }
        }
      ],
      palette:{
        
      }
    },
    userID: 0,
    owner: null,
    isPrivate: true,
    isDefault: false,
    isAcquisition: true,
    customConfig: {
      range: 8,
      fontSize: 1,
      scan: 2000
    },
    rtModule: true
};

const EAFDiffPress = ({ realtimeData, schemas, width }: IProps) => {

  return (
    <Card>
      <CardHeader title="EAF" sx={{ background: "rgba(0, 0, 0, 0.1)" }} />
      <CardContent sx={{ padding: 0 }}>
        <div className="m-2 display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr " }}>
          <div style={{ gridColumn: "1/6", marginBottom: "1em" }}>
            {schemas &&
              <AcquisitionChartWrapper
                realtime={realtimeData}
                component={dashboard.layout.components[0]}
                dashboard={dashboard}
                runtime={true}
                parentSize={{ width, height: 250 }}
                setDashboard={() => {}}
                schemas={schemas}/>
            }
          </div>

          <ItemValue title="COMPARTMENT 1"
                     value={realtimeData["EAFLOG.COMPARTMENT_1_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 2"
                     value={realtimeData["EAFLOG.COMPARTMENT_2_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 3"
                     value={realtimeData["EAFLOG.COMPARTMENT_3_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 4"
                     value={realtimeData["EAFLOG.COMPARTMENT_4_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 5"
                     value={realtimeData["EAFLOG.COMPARTMENT_5_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 6"
                     value={realtimeData["EAFLOG.COMPARTMENT_6_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 7"
                     value={realtimeData["EAFLOG.COMPARTMENT_7_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 8"
                     value={realtimeData["EAFLOG.COMPARTMENT_8_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 9"
                     value={realtimeData["EAFLOG.COMPARTMENT_9_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 10"
                     value={realtimeData["EAFLOG.COMPARTMENT_10_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 11"
                     value={realtimeData["EAFLOG.COMPARTMENT_11_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 12"
                     value={realtimeData["EAFLOG.COMPARTMENT_12_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="EAF OVERALL"
                     value={realtimeData["EAFLOG.OVERALL_DIFFERENTIAL_PRESSURE"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
        </div>
      </CardContent>
    </Card>
  );
}

export default EAFDiffPress;
